import { ActeurIcon } from "@logora/parliament.icons.regular_icons";
import { formatActeurSansGroupe, formatCapitalize, formatCell, formatGroupeParlementaire } from "../formatters";

const columns = [
	{
		header: "Nom",
		accessorKey: "acteurRef",
		cell: (info) => formatActeurSansGroupe(formatCell(info)),
	},
	{
		header: "Groupe politique",
		accessorKey: "acteurRef.groupeParlementaire",
		accessorFn: (originalRow) => originalRow.acteurRef?.groupeParlementaire,
		cell: (info) => formatGroupeParlementaire(formatCell(info)),
		enableSorting: false,
	},
	{
		header: "Présence",
		accessorKey: "presence",
		cell: (info) => formatCapitalize(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Présence",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: "présent", label: "Présent" },
					{ value: "absent", label: "Absent" },
					{ value: "excusé", label: "Excusé" },
				],
			},
		},
	},
];

export const participantReunionDataset = {
	key: "participants_reunions",
	name: "Participants",
	columns: columns,
	include: ["acteurRef.groupeParlementaire", "acteurRef.mandatPrincipal"],
	searchTable: "acteurRef",
	icon: <ActeurIcon height={20} width={20} />,
	searchPlaceholder: "Chercher un participant...",
	rowRedirect: (item) => `/parliament/acteurs/${item.acteurRefUid}`,
};
